import React, { useState } from 'react';
import { Box, Button, Drawer, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Logo from '../../../components/logo';
import Iconify from '../../../components/iconify';

function NavigationPopover() {
  const [loading, setLoading] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  setTimeout(() => {
    setLoading(true);
  }, 1000);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navLinks = [
    { label: 'Home', icon:"mdi-light:view-dashboard", path: ['/cloud/home', '/cloud/devices', '/cloud/device-app-update', '/cloud/device-profile', '/cloud/change-password', '/cloud/activity', '/cloud/reset-password', '/cloud/forgot-password'] },
    { label: 'Properties', icon:"solar:buildings-linear", path: ['/cloud/properties', '/cloud/add-property', '/cloud/update-property'] },
    { label: 'I AM', icon:"solar:shield-user-broken", path: ['/cloud/users', '/cloud/add-user', '/cloud/update-user', '/cloud/add-policy', '/cloud/update-policy', '/cloud/add-group', '/cloud/update-group'] },
  ];

  const drawer = (
    <Box sx={{ width: 250 }} role="presentation" onClick={handleDrawerToggle}>
      <List>
        <Box m={4}>
          <Logo/>
        </Box>
        {navLinks.map((link) => (
          <ListItem key={link.label} disablePadding>
            <ListItemButton component={RouterLink} to={link.path[0]} state={{ dropdownState: 'Users' }}>
              <Iconify icon={link.icon} sx={{display: 'inline-block', verticalAlign: 'middle', marginX:'2%', color: link.path.includes(location.pathname) ? 'primary.main' : 'text.secondary'}} width="17px" height="17px"/>
              <ListItemText
                primary={link.label}
                sx={{ color: link.path.includes(location.pathname) ? 'primary.main' : 'text.secondary', fontSize: '15px'}}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    loading && (
      <>
        <Iconify 
            icon="line-md:menu-unfold-left" 
            onClick={handleDrawerToggle} 
            sx={{ display: { md: 'none' }, color:'primary.main'}} 
            width="30px" 
            height="30px"
        />
        <Box sx={{  display: { xs: 'none', md: 'flex' } }}>
          {navLinks.map((link) => (
            <Button
              key={link.label}
              to={link.path[0]}
              state={{ dropdownState: 'Users' }}
              sx={{
                my: 2,
                color: link.path.includes(location.pathname) ? 'primary.main' : 'text.secondary',
                display: 'block',
                fontSize: '15px'
              }}
              component={RouterLink}
            >
              <Iconify icon={link.icon} sx={{display: 'inline-block', verticalAlign: 'middle'}} width="17px" height="17px" mb={0.5} mx={0.5}/>
              {link.label}
            </Button>
          ))}
        </Box>
        <Drawer
          anchor="left"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          sx={{ display: { xs: 'block', md: 'none' } }}
        >
          {drawer}
        </Drawer>
      </>
    )
  );
}

export default NavigationPopover;